import React, { useState } from "react";
import { Carousel, Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const HomeSlider = () => {
  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <>
      <Carousel
        className="bg-dark"
        activeIndex={index}
        onSelect={handleSelect}
        arrows={false}
        dots={true}
        autoplay={true}
        controls={false}
        interval={3000}
      >
        <Carousel.Item>
          <div
            id="bgImgSlide"
            style={{
              backgroundImage: "linear-gradient(0deg, rgba(26, 26, 26, 0.77), rgba(26, 26, 26, 0.13)),url(./assests/banners/slide1.jpg)",
              height: "450px",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              // background:'linear-gradient(0deg, rgba(26, 26, 26, 0), rgba(26, 26, 26, 0.13))'

            }}
          >
            <Container>
              <Row>
                <Col md={7}>
                  <h2 className="text-white fw-bold" id="headingFontSize">
                    Corporate Gifting
                    <br></br>Solutions That Stand Out.
                  </h2>
                  <p className="pText">
                    Boost your brand with unique, customized gifting experiences
                    that spark excitement, cultivate joy, and build lasting
                    connections with your employees and clients.
                  </p>
                  <Link to="/contact-us">
                    <Button id="btnPrimary">Get Started</Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div
            id="bgImgSlide"
            style={{
              backgroundImage: "linear-gradient(0deg, rgba(26, 26, 26, 0.77), rgba(26, 26, 26, 0.13)),url(./assests/banners/slide2.jpg)",
              height: "450px",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <Container>
              <Row>
                <Col md={7}>
                  <h2 className="text-white fw-bold" id="headingFontSize">
                  Seamless Onboarding
                    <br></br> with Premium Joining Kits
                  </h2>
                  <p className="pText">
                    Create an unforgettable first impression with thoughtfully curated joining kits and personalize the onboarding experience to make new employees feel valued. 
                  </p>
                  <Link to="/contact-us">
                     <Button id="btnPrimary">Get Started</Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div
            id="bgImgSlide"
            style={{
              backgroundImage: "linear-gradient(0deg, rgba(26, 26, 26, 0.77), rgba(26, 26, 26, 0.13)),url(./assests/banners/slide3.jpg)",
              height: "450px",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <Container>
              <Row>
                <Col md={7}>
                  <h2 className="text-white fw-bold" id="headingFontSize">
                  Your Brand, 
                    <br></br>Your Store – Curated for You
                  </h2>
                  <p className="pText">
                    Launch a customized brand store featuring premium merchandise that resonates with your company’s identity and offer a seamless gifting experience for employees and clients. 
                  </p>
                  <Link to="/contact-us">
                    <Button id="btnPrimary">Get Started</Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div
            id="bgImgSlide"
            style={{
              backgroundImage: "linear-gradient(0deg, rgba(26, 26, 26, 0.77), rgba(26, 26, 26, 0.13)),url(./assests/banners/slide4.jpg)",
              height: "450px",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <Container>
              <Row>
                <Col md={7}>
                  <h2 className="text-white fw-bold" id="headingFontSize">
                  Festive Gifting That 
                    <br></br>Creates Lasting Impressions.
                  </h2>
                  <p className="pText">
                    Celebrate the joy of festivals with bespoke corporate gifts and strengthen relationships to showcase your appreciation with thoughtfully chosen festive hampers.
                  </p>
                  <Link to="/contact-us">
                  <Button id="btnPrimary" className="glowing-border">Get Started</Button>
                  </Link>
                </Col>
              </Row>
            </Container>
          </div>
        </Carousel.Item>
      </Carousel>
    </>
  );
};

export default HomeSlider;
